import React, { useEffect, useState } from "react";

export default function Contact() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/Admin/public/api/contact`)
      .then((res) => res.json())
      .then((result) => {
        // 👇 IMPORTANT: nested data fix
        setData(result.data);
      })
      .catch((error) => {
        console.log("API Error:", error);
      });
  }, []);


  return (
    <div>
      <section>
        <h1 className="bg-white py-5 text-center">
 
      
          <br />
          {data?.email1 && (
            <div>
            For any enquiry message us at    <a href={`mailto:${data.email1}`}>{data.email1}</a>
             
            </div>
          )}
        
           
           </h1>

        {data && (
          <div className="text-center">
            <p>{data.message}</p>
          </div>
        )}
      </section>
    </div>
  );
}